module.exports = __webpack_public_path__ + "img/r-cb6-101-2.fec014f7.gif";